import React from "react";
import SignUpForm from "../../components/LogIn-SignUp/SignUpForm";
import IconButton from "../../components/IconButton/IconButton";
import { IconTypes } from "../../libs/Icon";
import { useDispatch } from "react-redux";
import RenderSocial from "../../components/Render-social";
import Footer from "../../components/Footer";
import useOutsideClick from "../../hooks/useOutsideClick";
import { useNavigate } from "react-router-dom";

import UseClosePopUpHandler from "../../hooks/useClosePopUpHandler";
import GetUrl from "../../hooks/GetUrl";

import styles from "./styles.module.scss";

const SignUp = () => {
  const path = GetUrl();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const modalRef = useOutsideClick(() => UseClosePopUpHandler(path, dispatch));

  return (
    <div className={styles.container}>
      <div className={styles.wrapper} ref={modalRef}>
        <h6 className={styles.title}>Create Account</h6>
        <IconButton
          buttonProps={{
            onClick: () => UseClosePopUpHandler(path, dispatch),
          }}
          className={styles.closeButton}
          size={32}
          type={IconTypes.CLOSE_DELETE}
        />
        <RenderSocial />
        <SignUpForm />
        <Footer
          goTo="Already have an account?"
          footerActionText="Log in"
          footerAction={() => {
            navigate("/");
            const modifiedUrl = window.location.pathname.replace(
              "/signup",
              "/"
            );
            navigate(modifiedUrl);
          }}
        />
      </div>
    </div>
  );
};

export default SignUp;
